import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import SidebarLink from "../fields/SidebarLink";

function Sidebar({ data }) {
    return (
        <div key={data.documentId} className="sidebar col-sm-2 no-padding" align="left">
            <div className="sidebar-links">
                <ul className="sidebar-list">
                    {/*MAP WAS MOVED TO SidebarLink js file*/}
                    {/*{data.sidebar_layout['sidebarLinks'].map((item, index) => (*/}
                    {/*    <li key={index} className="sidebar-list-item light-blue-text body-text">*/}
                    {/*        <a className={item['link']['url'].replace("/","").concat(" bold")} href={item['link']['url']}>*/}
                    {/*            {item['link']['label']} </a>*/}
                    {/*    </li>*/}
                    {/*))}*/}
                    {SidebarLink({data: data.sidebar_layout['sidebarLinks']})}
                </ul>
            </div>
            <div className="campaign-artwork">
            </div>
        </div>
    );
}

export default Sidebar;
